export default __webpack_public_path__ + "static/media/prado_vidigal.58d21528.png";